import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Route, Router } from '@angular/router';
import { SignupService } from '../services/signup.service';
import { patterns } from '../../assets/patterns';

@Component({
  selector: 'app-forgetpassword',
  templateUrl: './forgetpassword.component.html',
  styleUrls: ['./forgetpassword.component.css']
})
export class ForgetpasswordComponent implements OnInit {

  emailDetail: UntypedFormGroup;
  submitted: boolean = false;
  emailError: boolean;
  public loading = false;
  constructor(private formBuilder: UntypedFormBuilder, private router: Router, private signupService: SignupService) { }

  ngOnInit() {
    this.emailDetail = this.formBuilder.group({
      // email : ['', Validators.required]
      email: ['', Validators.compose([Validators.required, Validators.pattern(patterns.emailPattern)])]
    });
  }

  resetPassword() {
    this.submitted = true;
    this.loading = true;

    if (this.emailDetail.invalid) {
      this.loading = false;
      return;
    };

    this.signupService.requestPasswordReset(this.emailDetail.value)
      .subscribe((response) => {
        this.loading = false;
        this.emailDetail.reset();
        this.router.navigate(['/passwordrequestSuccess']);
      }, (error: HttpErrorResponse) => {
        this.loading = false;
        this.emailError = true;
        console.error('ForgetpasswordComponent_resetPassword', error);
      }
      )
  }

}
